import React from 'react'
import { ROLE, UserModel } from '@/features/users/types'

export const useUsersModel = () => {
  const isCustomer = (user: UserModel) => {
    return user?.role === ROLE.CUSTOMER
  }

  const getName = (user: UserModel | null | undefined) => {
    if (user) {
      let result = user?.name

      if (user?.last_name) {
        result = result ? `${result} ${user?.last_name}` : user?.last_name
      }

      return result
    }
    return null
  }

  return {
    isCustomer,
    getName,
  }
}
